import { Chip } from '@mui/material';

const COLOR_MAP: Record<string, 'default' | 'success' | 'warning' | 'error' | 'info'> = {
  ACTIVE: 'success',
  DONE: 'success',
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  DISABLED: 'error',
  FAILED: 'error',
  LOW: 'success',
  MEDIUM: 'warning',
  HIGH: 'error',
};

/** Status / priority pill — colors come from a small status→color map. */
export function StatusChip({ value }: { value: string | null | undefined }) {
  if (!value) return null;
  const color = COLOR_MAP[value] ?? 'default';
  return (
    <Chip
      size="small"
      label={value}
      color={color}
      variant={color === 'default' ? 'outlined' : 'filled'}
    />
  );
}
